<template>
  <div class="be-header-info w-100">
    <div class="be-header-info__top">
      <div class="be-header-info__main">
        <h1 class="be-header-info__name mb-2">{{ getMerchant.name }}</h1>
        <div class="be-header-info__meta">
          <span class="be-header-info__meta-item">
            <svg v-if="getMerchant.star > 0" height="18" width="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="18" height="18" rx="2" fill="#F7941D" />
              <path d="M12.452 10.353c-.151.146-.22.358-.186.566l.518 2.87c.044.243-.058.489-.262.63a.606.606 0 0 1-.682.047l-2.584-1.348a.55.55 0 0 0-.208-.076h-.158a.42.42 0 0 0-.162.052l-2.584 1.354a.606.606 0 0 1-.29.064.606.606 0 0 1-.52-.741l.519-2.87a.611.611 0 0 0-.186-.429L3.358 8.288a.611.611 0 0 1-.157-.66c.078-.23.278-.399.519-.437l2.899-.42a.611.611 0 0 0 .513-.356l1.277-2.62a.55.55 0 0 1 .117-.208l.052-.041a.412.412 0 0 1 .096-.03l.064-.023.099-.041h.245a.55.55 0 0 1 .494.353l1.294 2.607a.611.611 0 0 0 .486.355l2.899.42c.245.036.45.205.531.438a.611.611 0 0 1-.169.661l-2.182 2.065Z" fill="#fff" />
            </svg>
            <span class="be-header-info__category">{{ starCategoryText }}</span>
          </span>
          <span class="be-header-info__sep" v-if="getMerchant.address">•</span>
          <span class="be-header-info__meta-item" v-if="getMerchant.address">
            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.625 7.738C2.625 4.288 5.508 1.5 8.995 1.5c3.497 0 6.38 2.788 6.38 6.238 0 1.739-.632 3.353-1.673 4.72-1.148 1.51-2.563 2.824-4.156 3.856-.364.239-.693.257-1.093 0-1.602-1.032-3.017-2.346-4.155-3.855-1.042-1.367-1.673-2.98-1.673-4.721Zm4.271.194c0 1.156.943 2.065 2.099 2.065 1.157 0 2.11-.909 2.11-2.065 0-1.147-.953-2.1-2.11-2.1-1.156 0-2.099.953-2.099 2.1Z" fill="#777" />
            </svg>
            <a
              v-if="getMerchant.location_url"
              :href="getMerchant.location_url"
              target="_blank"
              rel="noopener"
              class="be-header-info__address">{{ getMerchant.address }}</a>
            <span v-else class="be-header-info__address">{{ getMerchant.address }}</span>
          </span>
        </div>
      </div>

      <button class="be-header-info__share be-press" @click="share">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="ml-2">{{ shareLabel }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { sharePage } from '@/utils/share.js';

export default {
  name: 'BeMerchantHeaderInfo',
  data() {
    return {
      copied: false,
    };
  },
  computed: {
    ...mapGetters(['getMerchant']),
    starCategoryText() {
      const { star, merchant_category_name } = this.getMerchant;
      const category = this.$capitalize
        ? this.$capitalize(merchant_category_name || '', true)
        : merchant_category_name || '';
      if (!star) return category;
      const starWord = this.$pluralWord ? this.$pluralWord(star, 'Star') : 'Stars';
      return `${star} ${starWord} ${category}`.trim();
    },
    shareLabel() {
      return this.copied ? this.$t('general.link-copied') : 'Share';
    },
  },
  beforeDestroy() {
    clearTimeout(this.copiedTimer);
  },
  methods: {
    share() {
      sharePage(this.getMerchant.name).then((isCopied) => {
        if (!isCopied) return;
        this.copied = true;
        this.copiedTimer = setTimeout(() => {
          this.copied = false;
        }, 2000);
      });
    },
  },
};
</script>

<style scoped>
.be-header-info__name {
  font-family: var(--be-v3-title-font, BeV3Sans), sans-serif;
  font-weight: 700;
  color: #1a1a2e;
  font-size: 24px;
  line-height: 1.2;
}
/* mobile: rating and address each get their own line, sharing moves to the floating
   navbar over the hero, and a rule closes the block off from the description below */
.be-header-info {
  padding-bottom: 26px;
  border-bottom: 1px solid #e8e8e8;
}
.be-header-info__top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.be-header-info__main {
  width: 100%;
}
.be-header-info__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  color: #555;
  font-size: 15px;
}
.be-header-info__meta-item {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
}
.be-header-info__meta-item > svg {
  flex-shrink: 0;
  margin-top: 2px;
}
.be-header-info__category {
  font-weight: 400;
  color: #333;
}
.be-header-info__sep {
  display: none;
  color: #ccc;
}
.be-header-info__address {
  color: #555;
  text-decoration: underline;
}
.be-header-info__address:hover {
  color: var(--merchant-primary-color, #79a33a);
}
.be-header-info__share {
  display: none;
  align-items: center;
  border: 1px solid #e2e2e2;
  background: #fff;
  color: #1a1a2e;
  border-radius: var(--be-v3-button-radius, 8px);
  padding: 8px 16px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.be-header-info__share:hover {
  border-color: var(--merchant-primary-color, #79a33a);
  background: #fafafa;
}
@media screen and (min-width: 768px) {
  .be-header-info {
    padding-bottom: 0;
    border-bottom: none;
  }
  .be-header-info__name {
    font-size: 40px;
  }
  .be-header-info__top {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
  }
  .be-header-info__main {
    width: auto;
    padding-right: 16px;
  }
  .be-header-info__meta {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 0 8px;
  }
  .be-header-info__meta-item > svg {
    margin-top: 0;
  }
  .be-header-info__sep {
    display: inline;
  }
  .be-header-info__share {
    display: inline-flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BeMerchantHeaderInfo.vue